const words = (t) => (t || "").trim().split(/\s+/).filter(Boolean).length;

export default function FrtSection({ section, value, onChange, onLockPhase1, integrity }) {
  return (
    <div className="space-y-6" data-testid="frt-section">
      {section.items.map((item) => {
        const blob = value[item.id] || {};
        const locked = Boolean(blob.phase1_locked_at);
        const set = (patch) => onChange({ ...value, [item.id]: { ...blob, ...patch } });
        return (
          <div key={item.id} className="space-y-4" data-testid={`frt-item-${item.id}`}>
            <div className="cand-card rounded-lg p-5 sm:p-6">
              <p className="font-data text-xs text-[color:var(--cand-muted)] mb-2">Phase 1</p>
              <p className="text-sm sm:text-base leading-relaxed">{item.phase1_prompt}</p>
              <textarea
                className="mt-4 w-full border rounded p-3 text-sm min-h-[170px] leading-relaxed focus:outline-none focus:ring-2 focus:ring-[#EA580C] disabled:bg-[#FAFAF9]"
                value={blob.phase1 || ""}
                disabled={locked}
                placeholder="Your reading of the situation and your first three actions."
                data-testid={`frt-phase1-answer-${item.id}`}
                onKeyDown={(e) => integrity?.onKeyDown(`${item.id}-phase1`, e)}
                onPaste={(e) => integrity?.onPaste(`${item.id}-phase1`, e)}
                onCopy={() => integrity?.onCopy(`${item.id}-phase1`)}
                onChange={(e) => {
                  integrity?.setLength(`${item.id}-phase1`, e.target.value.length);
                  set({ phase1: e.target.value });
                }}
              />
              <div className="flex items-center justify-between mt-3">
                <span className="text-xs font-data text-[color:var(--cand-muted)]">
                  {words(blob.phase1)} words
                </span>
                {!locked && (
                  <button
                    className="btn-accent rounded px-5 py-2 text-sm"
                    disabled={words(blob.phase1) < 20}
                    data-testid={`frt-lock-phase1-${item.id}`}
                    onClick={async () => {
                      set({ phase1_locked_at: new Date().toISOString() });
                      if (onLockPhase1) setTimeout(onLockPhase1, 50);
                    }}
                  >
                    Lock Phase 1 and reveal new information
                  </button>
                )}
                {locked && (
                  <span className="text-xs font-data text-[color:var(--cand-muted)]" data-testid={`frt-phase1-locked-${item.id}`}>
                    Phase 1 locked
                  </span>
                )}
              </div>
            </div>

            {locked && (
              <>
                <div
                  className="rounded-lg p-5 sm:p-6 border-l-4"
                  style={{ background: "#FFF7ED", borderColor: "var(--cand-accent)" }}
                  data-testid={`frt-reveal-${item.id}`}
                >
                  <p className="font-data text-xs text-[color:var(--cand-accent)] mb-2">
                    New field information
                  </p>
                  <p className="text-sm sm:text-base leading-relaxed">{item.phase2_reveal}</p>
                </div>
                <div className="cand-card rounded-lg p-5 sm:p-6">
                  <p className="font-data text-xs text-[color:var(--cand-muted)] mb-2">Phase 2</p>
                  <p className="text-sm sm:text-base leading-relaxed">{item.phase2_prompt}</p>
                  <textarea
                    className="mt-4 w-full border rounded p-3 text-sm min-h-[170px] leading-relaxed focus:outline-none focus:ring-2 focus:ring-[#EA580C]"
                    value={blob.phase2 || ""}
                    placeholder="What changes, what stays, and what the change cost."
                    data-testid={`frt-phase2-answer-${item.id}`}
                    onKeyDown={(e) => integrity?.onKeyDown(`${item.id}-phase2`, e)}
                    onPaste={(e) => integrity?.onPaste(`${item.id}-phase2`, e)}
                    onCopy={() => integrity?.onCopy(`${item.id}-phase2`)}
                    onChange={(e) => {
                      integrity?.setLength(`${item.id}-phase2`, e.target.value.length);
                      set({ phase2: e.target.value });
                    }}
                  />
                  <div className="flex justify-between text-xs mt-2 font-data text-[color:var(--cand-muted)]">
                    <span>{words(blob.phase2)} words</span>
                    <span>aim for at least {item.min_words}</span>
                  </div>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}
